export default __webpack_public_path__ + "static/media/units-black.4af79de0.svg";